export enum LocationType {
  Neighbourhood = 'neighbourhood',
  Borough = 'borough',
  Village = 'village',
  City = 'city',
  Province = 'province',
  Country = 'country',
  Continent = 'continent',
}

export interface Location {
  id: number;
  creationDate?: string;
  name: string;
  type: LocationType;
  lat: number;
  lng: number;
  radius: number;
  parentLocation?: Location;
}

export const nameRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];

export const descriptionRules = [
  (value: string) => {
    if (value) return true;

    return 'Description is required.';
  },
];

export const locationTypes = [
  { title: 'Neighbourhood', value: LocationType.Neighbourhood },
  { title: 'Borough', value: LocationType.Borough },
  { title: 'Village', value: LocationType.Village },
  { title: 'City', value: LocationType.City },
  { title: 'Province', value: LocationType.Province },
  { title: 'Country', value: LocationType.Country },
  { title: 'Continent', value: LocationType.Continent },
];
